import { render, staticRenderFns } from "./NeedsReview.vue?vue&type=template&id=ed2a38e4&scoped=true&"
import script from "./NeedsReview.vue?vue&type=script&lang=js&"
export * from "./NeedsReview.vue?vue&type=script&lang=js&"
import style0 from "./NeedsReview.vue?vue&type=style&index=0&id=ed2a38e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2a38e4",
  null
  
)

export default component.exports